import PageGroupType from '../components/PageGroupType';
import SearchLinkTagByPageGroup from '../components/SearchLinkTagByPageGroup';

export default function getTagCharacterForSearchLink(category) {
    switch (category) {
        case PageGroupType.FAMILY:
            return SearchLinkTagByPageGroup.FAMILY;
        case PageGroupType.CUSTOMER:
            return SearchLinkTagByPageGroup.CUSTOMER;
        case PageGroupType.PLATFORM:
            return SearchLinkTagByPageGroup.PLATFORM;
        default:
            return '';
    }
}
